const evaluateValues = (params: Object, data: any) => {
    let evaluatedParams: { [key: string]: string } = {};
    Object.entries(params).forEach(([key, value]) => {
        if (value.fact) {
            if (data[value.fact]) {
                evaluatedParams[key] = data[value.fact];
            }
        } else {
            evaluatedParams[key] = value;
        }
    });
    return evaluatedParams;
};

function composeParams(params: Object, data: any) {
    let queryParams;

    if (params) {
        let paramsList = [];
        const evaluatedParams = evaluateValues(params, data);

        paramsList = Object.entries(evaluatedParams).map((param) => {
            return param.map((item) => encodeURIComponent(item)).join('=');
        });
        queryParams = paramsList.join('&');
    }

    return queryParams || '';
}

const parseParamValues = (paramValue: any) => {
    let parsedParamObject: any;
    if (typeof paramValue !== 'object' || paramValue === null) {
        return paramValue; // Return the value if ParamValue is not an object
    }
    if (!!paramValue.fact && paramValue.fact === '$value') {
        return '$value';
    }
    if (!!paramValue.fact && paramValue.fact === '_context') {
        return '_context' + paramValue.path;
    }
    if (!!paramValue.fact) {
        return '_fact' + paramValue.fact;
    }
    parsedParamObject = Array.isArray(paramValue) ? [] : {};
    for (const prop in paramValue) {
        parsedParamObject[prop] = parseParamValues(paramValue[prop]);
    }
    return parsedParamObject;
};

const getEvaluatedParamsForSearch = (params: Object) => {
    let evaluatedParams: { [param: string]: string } = {};
    Object.entries(params).forEach(([param, paramValue]) => {
        evaluatedParams[param] = parseParamValues(paramValue);
    });
    return evaluatedParams;
};
function composeParamsForSearch(params: Object) {
    let queryParams;

    if (params) {
        let paramsList = [];
        const evaluatedParams = getEvaluatedParamsForSearch(params);

        paramsList = Object.entries(evaluatedParams).map((param) => {
            return param.map((item) => JSON.stringify(item)).join('=');
        });
        queryParams = paramsList.join('&');
    }
    return queryParams || '';
}

export { composeParams, evaluateValues, composeParamsForSearch, getEvaluatedParamsForSearch };
